export default __webpack_public_path__ + "static/media/MRK-VEIN.4b2c48ef.png";